import { render, staticRenderFns } from "./only_goods_page.vue?vue&type=template&id=21f3cd1e&scoped=true"
import script from "./only_goods_page.vue?vue&type=script&lang=js"
export * from "./only_goods_page.vue?vue&type=script&lang=js"
import style0 from "./only_goods_page.vue?vue&type=style&index=0&id=21f3cd1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3cd1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f3cd1e')) {
      api.createRecord('21f3cd1e', component.options)
    } else {
      api.reload('21f3cd1e', component.options)
    }
    module.hot.accept("./only_goods_page.vue?vue&type=template&id=21f3cd1e&scoped=true", function () {
      api.rerender('21f3cd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/source/only_goods_page.vue"
export default component.exports